import type {RefObject} from 'react';
import React from 'react';

import CSSModules from 'react-css-modules';

import Button from '../../Button';
import Text from '../../TextComponents/Text';

import colourStyles from '../../../resources/styles/colours.module.scss';
import styles from './styles.module.scss';

type TaskBoxButtonProps = {
  containerRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLElement>;
  text: string;
  onClick: () => void;
  isDisabled?: boolean;
};

const TaskBoxButton = ({
  containerRef,
  contentRef,
  text,
  onClick,
  isDisabled,
}: TaskBoxButtonProps) => (
  <div ref={containerRef} styleName='button'>
    <Button
      onClick={onClick}
      type='custom'
      customColour={colourStyles.white}
      customFontColour={colourStyles.textPrimary}
      customHoverFontColour={colourStyles.errorPrimary}
      customDarkColour={colourStyles.grey050}
      noMarginLeft
      disabled={isDisabled}
      dataAutomation='component-button'
    >
      <Text maxLines={2} size='m' colour='textPrimary'>
        <span ref={contentRef}>{text}</span>
      </Text>
    </Button>
  </div>
);

export default CSSModules(TaskBoxButton, styles);
